exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex[data-v-959b1b64]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.bg-img[data-v-959b1b64]{position:relative;height:620px;width:375px;margin:auto}.bg-img .img-box[data-v-959b1b64]{width:100%;height:100%;position:absolute;top:-10px;left:0;pointer-events:none}.bg-img .iframe-box[data-v-959b1b64]{width:375px;height:95%;border-radius:36px;overflow:auto;padding-top:18px;pointer-events:auto}.bg-img .iframe-box iframe[data-v-959b1b64]{padding:0;margin:0}[data-v-959b1b64] .el-drawer__body{overflow:scroll;padding-bottom:20px}", ""]);

// exports
